(function () {
  'use strict';

  function klaviyoPost(siteId, path, payload) {
    return fetch('https://a.klaviyo.com/client/' + path + '/?company_id=' + encodeURIComponent(siteId), {
      method: 'POST',
      headers: {
        'Content-Type': 'application/vnd.api+json',
        Accept: 'application/vnd.api+json',
        revision: '2026-01-15',
      },
      body: JSON.stringify(payload),
    }).then(function (res) {
      if (res.ok) return res;
      return res.json().catch(function () { return {}; }).then(function (d) {
        throw new Error((d && d.errors && d.errors[0] && d.errors[0].detail) || 'Klaviyo error');
      });
    });
  }

  function klaviyoSubscribe(siteId, listId, firstName, email, formData, market) {
    return klaviyoPost(siteId, 'subscriptions', {
      data: {
        type: 'subscription',
        attributes: {
          custom_source: 'Shopify launch landing',
          profile: {
            data: {
              type: 'profile',
              attributes: {
                email: email,
                first_name: firstName,
                properties: {
                  last_launch_key:      formData.launchKey,
                  last_launch_name:     formData.launchName,
                  last_launch_date:     formData.launchDate,
                  last_launch_date_iso: formData.launchDateIso,
                  last_launch_month:    formData.month,
                  last_launch_market:   market,
                },
                subscriptions: {
                  email: {
                    marketing: {
                      consent: 'SUBSCRIBED',
                    },
                  },
                },
              },
            },
          },
        },
        relationships: {
          list: { data: { type: 'list', id: listId } },
        },
      },
    });
  }

  function klaviyoEvent(siteId, eventName, firstName, email, formData, market) {
    return klaviyoPost(siteId, 'events', {
      data: {
        type: 'event',
        attributes: {
          metric: { data: { type: 'metric', attributes: { name: eventName } } },
          profile: { data: { type: 'profile', attributes: { email: email, first_name: firstName } } },
          properties: {
            launch_key:      formData.launchKey,
            launch_name:     formData.launchName,
            launch_label:    formData.launchLabel,
            launch_date:     formData.launchDate,
            launch_date_iso: formData.launchDateIso,
            month:           formData.month,
            market:          market,
            page_url:        window.location.href,
          },
          unique_id: (formData.launchKey || 'launch') + '-' + Date.now(),
        },
      },
    });
  }

  function setupForm(form, cfg) {
    var button   = form.querySelector('[data-launch-submit]');
    var label    = form.querySelector('[data-launch-submit-label]');
    var statusEl = form.querySelector('[data-form-status]');
    var nameEl   = form.querySelector('input[name="first_name"]');
    var emailEl  = form.querySelector('input[name="email"]');
    var honeypot = form.querySelector('input[name="company"]');

    if (!button || !nameEl || !emailEl) return;

    function setStatus(msg, state) {
      if (!statusEl) return;
      statusEl.textContent = msg;
      statusEl.className = 'launch-launch-card__status' + (state ? ' is-' + state : '');
    }

    function setPending(on) {
      button.disabled = on;
      if (label) label.textContent = on ? 'Sending...' : 'Notify Me';
      form.classList.toggle('is-pending', on);
    }

    function syncReady() {
      var ok = nameEl.value.trim().length > 0 && emailEl.value.trim().length > 0 && emailEl.checkValidity();
      form.classList.toggle('is-ready', ok);
    }

    form.querySelectorAll('.launch-launch-card__field-input').forEach(function (field) {
      field.addEventListener('input', function () {
        syncReady();
        if (statusEl && !statusEl.classList.contains('is-success')) setStatus('', '');
      });
    });

    button.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();

      var firstName = nameEl.value.trim();
      var email     = emailEl.value.trim().toLowerCase();

      if (!firstName || !email || !emailEl.checkValidity()) {
        setStatus('Please enter your name and a valid email address.', 'error');
        return;
      }

      var listId = form.dataset.listId || cfg.listId;

      if (!cfg.siteId || !listId) {
        setStatus('Form unavailable right now. Please try again later.', 'error');
        return;
      }

      setStatus('Sending...', '');
      setPending(true);

      var formData = {
        launchKey:     form.dataset.launchKey     || '',
        launchName:    form.dataset.launchName    || '',
        launchLabel:   form.dataset.launchLabel   || '',
        launchDate:    form.dataset.launchDate    || '',
        launchDateIso: form.dataset.launchDateIso || '',
        month:         form.dataset.launchMonth   || '',
      };

      klaviyoSubscribe(cfg.siteId, listId, firstName, email, formData, cfg.market)
        .then(function () {
          return klaviyoEvent(cfg.siteId, cfg.eventName, firstName, email, formData, cfg.market);
        })
        .then(function () {
          form.reset();
          setStatus(cfg.successMessage, 'success');
          syncReady();
        })
        .catch(function (err) {
          console.error('Launch form error:', err);
          setStatus('Could not save your request. Please try again.', 'error');
        })
        .finally(function () {
          setPending(false);
        });
    });

    syncReady();
  }

  function setupGallery(card) {
    var thumbs    = Array.from(card.querySelectorAll('[data-gallery-thumb]'));
    var mainImage = card.querySelector('[data-main-image]');
    var viewer    = card.querySelector('[data-gallery-viewer]');
    var zoomBtn   = card.querySelector('[data-zoom-trigger]');

    if (!thumbs.length || !mainImage || !viewer) return;

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        if (thumb.classList.contains('is-active')) return;
        var nextSrc     = thumb.dataset.imageSrc  || '';
        var nextAlt     = thumb.dataset.imageAlt  || '';
        var nextMediaId = thumb.dataset.mediaId   || '';
        if (!nextSrc) return;

        thumbs.forEach(function (t) {
          t.classList.remove('is-active');
          t.removeAttribute('aria-current');
        });
        thumb.classList.add('is-active');
        thumb.setAttribute('aria-current', 'true');
        viewer.classList.add('is-switching-out');

        var preload = new Image();
        preload.onload = function () {
          setTimeout(function () {
            mainImage.src = nextSrc;
            mainImage.alt = nextAlt;
            if (zoomBtn && nextMediaId) zoomBtn.setAttribute('data-media-id', nextMediaId);
            viewer.classList.remove('is-switching-out');
            viewer.classList.add('is-switching-in');
            setTimeout(function () { viewer.classList.remove('is-switching-in'); }, 260);
          }, 140);
        };
        preload.onerror = function () { viewer.classList.remove('is-switching-out'); };
        preload.src = nextSrc;
      });
    });
  }

  function setupZoomModal(card) {
    var modal = card.querySelector('.launch-product-media-modal');
    var stage = card.querySelector('.launch-launch-card__zoom-stage');
    if (!modal || !stage || modal.dataset.outsideCloseBound) return;
    modal.dataset.outsideCloseBound = '1';
    modal.addEventListener('click', function (e) {
      if (!modal.hasAttribute('open') || stage.contains(e.target)) return;
      if (typeof modal.hide === 'function') modal.hide();
    });
  }

  function setupTabs(root) {
    var tabs         = Array.from(root.querySelectorAll('[data-month-tab]'));
    var panels       = Array.from(root.querySelectorAll('[data-month-panel]'));
    var defaultMonth = root.dataset.defaultMonth;

    function activateMonth(month) {
      var target = null;
      for (var i = 0; i < panels.length; i++) {
        if (panels[i].dataset.monthPanel === month) { target = panels[i]; break; }
      }
      if (!target) target = panels[0];
      if (!target) return;

      tabs.forEach(function (t) {
        var active = t.dataset.monthTab === target.dataset.monthPanel;
        t.classList.toggle('is-active', active);
        t.setAttribute('aria-selected', active ? 'true' : 'false');
        t.setAttribute('tabindex', (active && !t.disabled) ? '0' : '-1');
      });

      panels.forEach(function (p) {
        var active = p === target;
        p.hidden = !active;
        p.classList.toggle('is-active', active);
      });
    }

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        if (!tab.disabled) activateMonth(tab.dataset.monthTab);
      });
    });

    if (defaultMonth) activateMonth(defaultMonth);
    var hashVal = window.location.hash.slice(1);
    if (hashVal) {
      var cardEl = document.getElementById(hashVal);
      var scrollTarget = null;
      if (cardEl && cardEl.closest('[data-month-panel]')) {
        activateMonth(cardEl.closest('[data-month-panel]').dataset.monthPanel);
        scrollTarget = cardEl;
      } else {
        activateMonth(hashVal);
        for (var i = 0; i < panels.length; i++) {
          if (panels[i].dataset.monthPanel === hashVal) { scrollTarget = panels[i]; break; }
        }
      }
      if (scrollTarget) {
        setTimeout(function () {
          var stickyEl = document.querySelector('sticky-header') || document.querySelector('.header-wrapper') || document.querySelector('header');
          var offset = stickyEl ? stickyEl.offsetHeight : 60;
          window.scrollTo({ behavior: 'smooth', top: window.scrollY + scrollTarget.getBoundingClientRect().top - offset });
        }, 150);
      }
    }
  }

  function sortCards(root) {
    root.querySelectorAll('[data-month-panel]').forEach(function (panel) {
      var container = panel.querySelector('.launch-coming-soon__month-cards');
      if (!container) return;
      var cards = Array.from(container.querySelectorAll('[data-card-root]'));
      if (cards.length < 2) return;
      cards.sort(function (a, b) {
        var ak = a.dataset.sortKey || '9999-12-31';
        var bk = b.dataset.sortKey || '9999-12-31';
        return ak < bk ? -1 : ak > bk ? 1 : 0;
      });
      cards.forEach(function (card) { container.appendChild(card); });
    });
  }

  function init(scope) {
    var roots = (scope || document).querySelectorAll('launch-coming-soon');
    roots.forEach(function (root) {
      if (root.dataset.lcsInit) return;
      root.dataset.lcsInit = '1';

      var cfg = {
        siteId:         root.dataset.klaviyoSiteId         || '',
        listId:         root.dataset.klaviyoListId         || '',
        eventName:      root.dataset.klaviyoEventName      || 'Launch Interest Submitted',
        successMessage: root.dataset.klaviyoSuccessMessage || "You're on the list. We'll let you know before the drop.",
        market:         root.dataset.market                || 'USA',
      };

      sortCards(root);
      setupTabs(root);

      root.querySelectorAll('[data-card-root]').forEach(function (card) {
        setupGallery(card);
        setupZoomModal(card);
        var form = card.querySelector('[data-launch-form]');
        if (form) setupForm(form, cfg);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (e) { init(e.target); });

}());
